import { FC, useEffect, useState } from 'react';

import { useVideoContext } from '../../VideoController/VideoController.context';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { Content } from '../../../../types/tour';
import { useGetStartedContext } from '../../../Shared/GetStarted/GetStarted.context';

const codeSample = `
export const App = () => {
  // ...
	useEffect(() => {
	  call.join({ create: true }).catch(err => {
      console.error('Failed to join the call', err);
		});
	}, [call]);
	
	return (
	  <StreamVideo client={client}>
	    <StreamCall call={call}>
	      <StreamTheme>
	        <UI />
	      </StreamTheme>
	    </StreamCall>
	  </StreamVideo>
	);
}
	
export const UI = () => {
  return (
    <>
      <PaginatedGridLayout />
      <CallControls />
    </>
  );
};
`;

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
};

export const Step4: FC<Props> = ({ setComplete, content }) => {
  const { setJoined, state } = useVideoContext();
  const { state: getStartedState } = useGetStartedContext();

  const run = async () => {
    state?.call.join({ create: true }).catch((err: Error) => {
      console.error('Failed to join the call', err);
    });
    setComplete();
    setJoined(true);
  };

  return (
    <ContentGenerator
      content={content}
      demoLink={`https://getstream.io/video/demos/?id=${state.call.id}`}
      demoText="Video Calling Demo"
      code={
        <Code
          language="jsx"
          footer={{
            label: 'Join Call',
            disabled: getStartedState.steps[getStartedState.current].completed,
            run,
          }}
        >
          {codeSample}
        </Code>
      }
    />
  );
};
